import { Field, Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

// OAuth 2.0 client credentials flow: the Connected App's Run As user decides what we can read.
type SalesforceConfig = {
  domainUrl: string;
  clientId: string;
  clientSecret: string;
};

export const SalesforceConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as SalesforceConfig) ?? {
    domainUrl: "",
    clientId: "",
    clientSecret: ""
  };

  const update = (changes: Partial<SalesforceConfig>) =>
    onChange({ credentials: { ...credentials, ...changes } });

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="My Domain URL">
        <TextInput
          placeholder="https://yourcompany.my.salesforce.com"
          value={credentials.domainUrl}
          onChange={domainUrl => update({ domainUrl })}
        />
      </Field>
      <Field title="Consumer key">
        <TextInput
          placeholder="Consumer key"
          value={credentials.clientId}
          onChange={clientId => update({ clientId })}
        />
      </Field>
      <Field title="Consumer secret">
        <TextInput
          placeholder="Consumer secret"
          value={credentials.clientSecret}
          type="password"
          onChange={clientSecret => update({ clientSecret })}
        />
      </Field>
    </Layout.Group>
  );
};
